/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react'
import moment from "moment";
import frLocale from "moment/locale/fr";
import axios from "axios";
import {  useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { userActions } from "../_actions";


export const changeDateFormatFrench =(date)=>{
    moment.locale('fr', [frLocale])
    
    return moment(date).format('LL');
}

export const changeDateFormatFrenchDynamic =(date,dateformat='LL')=>{
    moment.locale('fr', [frLocale])
    
    return moment(date).format(dateformat);
}
export const convertNumberFrench =(get_number)=>{       
    const number = Number(get_number);
    return number.toLocaleString("fr-FR");
}
export const isValidEmail =(email)=>{ 
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
}

export const isAlphabetic =(inputVal)=>{ 
    const regex = /^[A-Za-z\s]+$/;
    return (typeof inputVal === "string" && inputVal.length>0 && regex.test(inputVal));
}
export const isValidPhoneNumber = (phone) => {
    if (!phone) return false;
    // Remove all spaces and check if it matches the pattern
    const cleanedPhone = phone.replace(/\s/g, '');
    return /^0[1-9]\d{8}$/.test(cleanedPhone);
};
export const isNumericValue =(value)=>{ 
    return value.length>0 && /^\d*$/.test(value);
}
export const isNumberValue =(value)=>{ 
    const regex = /^[0-9\b]+$/;
    return value.length>0 && regex.test(value);
}

export const getDetailsBySiren =async(sirenNo)=>{
    try {       
        const fetchResponse = await axios.get(`${process.env.REACT_APP_API_URL}api/announce/sirenDetails/${sirenNo}`);       
        if(fetchResponse){
            return fetchResponse.data.data;

        }else{
            return {
                siren:"", denomination:"", forme_juridique:"",capital_social:"",adresse_rcs:"", code_postal:"",ville:"", area:"",cityArr:[],ville_id:"",
            };
        }
    } catch (e) {
        // return e;
        return {
            siren:"", denomination:"", forme_juridique:"",capital_social:"",adresse_rcs:"", code_postal:"",ville:"", area:"",cityArr:[],ville_id:""
        };
    } 
    
}
export const decodedStringValue =(value)=>{ 
    let encodedString = value;
    let div = document.createElement('div');
    div.innerHTML = encodedString;
    let decodedString = div.innerText || div.textContent;
    return decodedString;
}


export const LogoutApp = () => {
    /* const dispatch = useDispatch();
    let navigate = useNavigate();
    dispatch(userActions.logout()); */
    const keysToRemove = ['user_pro', 'email', 'id', 'token'];
  
    keysToRemove.forEach(key => {
    localStorage.removeItem(key);
    });
    setTimeout(() => {
    //   navigate("/");
      window.location.href="/"
    }, 1000);
  }


  export const getMonthsStartingWithCurrent = () => {
    const monthNames = [
      'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
    ];
  
    const currentMonthIndex = new Date().getMonth();
    const monthsStartingWithCurrent = [
      ...monthNames.slice(currentMonthIndex),
      ...monthNames.slice(0, currentMonthIndex)
    ];
  
    return monthsStartingWithCurrent;
  };

export const isValidSIRET = (siret) => {
    if (siret.length !== 14 || isNaN(siret)) {
      return false;
    }
  
    let sum = 0;
    for (let i = 0; i < 14; i++) {
      let digit = parseInt(siret[i], 10);
  
      // Double every second digit
      if (i % 2 === 0) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }
      sum += digit;
    }
  
    return sum % 10 === 0;
};

// Basic Regex pattern for French TVA
export const isValidTVA = (tva) => {
    const regex = /^FR[0-9A-Z]{2}[0-9]{9}$/;
    return regex.test(tva);
};

// NAF validation: 4 digits followed by 1 letter (e.g., "1234Z")
export const isValidNAF = (naf) => {
    const nafRegex = /^[0-9]{4}[A-Z]$/;
    return nafRegex.test(naf);
};
  
// Function to validate French IBAN (27 characters starting with 'FR')
export const validateIBAN = (iban) => {
    const ibanRegex = /^FR\d{12}[A-Z0-9]{11}\d{2}$/; // FR IBAN with 27 characters
    return ibanRegex.test(iban.replace(/\s+/g, "")); // Remove spaces before testing
};

// Function to format the IBAN in blocks of 4 characters
export const formatIBAN = (iban) => {
    return iban.replace(/\s+/g, '').replace(/(.{4})/g, '$1 ').trim();
};

export const validateBIC = (bic) => {
    const bicRegex = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
    return bicRegex.test(bic.replace(/\s+/g, ""));
  };
  
export const generateRandomString = (length = 24) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return "pi_" + result;
}
export function getFormJuridique(code) {
  const forms = {
    "0000": "Organisme de placement collectif en valeurs mobilières sans personnalité morale",
    "1000": "Entrepreneur individuel",
    "2110": "Indivision entre personnes physiques",
    "2120": "Indivision avec personne morale",
    "2210": "Société créée de fait entre personnes physiques",
    "2220": "Société créée de fait avec personne morale",
    "2310": "Société en participation entre personnes physiques",
    "2320": "Société en participation avec personne morale",
    "2385": "Société en participation de professions libérales",
    "2400": "Fiducie",
    "2700": "Paroisse hors zone concordataire",
    "2900": "Autre groupement de droit privé non doté de la personnalité morale",
    "3110": "Représentation ou agence commerciale d'état ou organisme public étranger immatriculé au RCS",
    "3120": "Société commerciale étrangère immatriculée au RCS",
    "3205": "Organisation internationale",
    "3210": "État, collectivité ou établissement public étranger",
    "3220": "Société étrangère non immatriculée au RCS",
    "3290": "Autre personne morale de droit étranger",
    "4110": "Établissement public national à caractère industriel ou commercial doté d'un comptable public",
    "4120": "Établissement public national à caractère industriel ou commercial non doté d'un comptable public",
    "4130": "Exploitant public",
    "4140": "Établissement public local à caractère industriel ou commercial",
    "4150": "Régie d'une collectivité locale à caractère industriel ou commercial",
    "4160": "Institution Banque de France",
    "5191": "Société de caution mutuelle",
    "5192": "Société coopérative de banque populaire",
    "5193": "Caisse de crédit maritime mutuel",
    "5194": "Caisse (fédérale) de crédit mutuel",
    "5195": "Association coopérative inscrite (droit local Alsace Moselle)",
    "5196": "Caisse d'épargne et de prévoyance à forme coopérative",
    "5202": "Société en nom collectif",
    "5203": "Société en nom collectif coopérative",
    "5306": "Société en commandite simple",
    "5307": "Société en commandite simple coopérative",
    "5308": "Société en commandite par actions",
    "5309": "Société en commandite par actions coopérative",
    "5310": "Société en libre partenariat (SLP)",
    "5370": "Société de Participations Financières de Profession Libérale Société en commandite par actions (SPFPL SCA)",
    "5385": "Société d'exercice libéral en commandite par actions",
    "5410": "SARL nationale",
    "5415": "SARL d'économie mixte",
    "5422": "SARL immobilière pour le commerce et l'industrie (SICOMI)",
    "5426": "SARL immobilière de gestion",
    "5430": "SARL d'aménagement foncier et d'équipement rural (SAFER)",
    "5431": "SARL mixte d'intérêt agricole (SMIA)",
    "5432": "SARL d'intérêt collectif agricole (SICA)",
    "5442": "SARL d'attribution",
    "5443": "SARL coopérative de construction",
    "5451": "SARL coopérative de consommation",
    "5453": "SARL coopérative artisanale",
    "5454": "SARL coopérative d'intérêt maritime",
    "5455": "SARL coopérative de transport",
    "5458": "SARL coopérative ouvrière de production (SCOP)",
    "5459": "SARL union de sociétés coopératives",
    "5460": "Autre SARL coopérative",
    "5470": "Société de Participations Financières de Profession Libérale Société à responsabilité limitée (SPFPL SARL)",
    "5485": "Société d'exercice libéral à responsabilité limitée",
    "5498": "SARL unipersonnelle",
    "5499": "Société à responsabilité limitée (sans autre indication)",
    "5505": "SA à participation ouvrière à conseil d'administration",
    "5510": "SA nationale à conseil d'administration",
    "5515": "SA d'économie mixte à conseil d'administration",
    "5520": "Fonds à forme sociétale à conseil d'administration",
    "5522": "SA immobilière pour le commerce et l'industrie (SICOMI) à conseil d'administration",
    "5525": "SA immobilière d'investissement à conseil d'administration",
    "5530": "SA d'aménagement foncier et d'équipement rural (SAFER) à conseil d'administration",
    "5531": "Société anonyme mixte d'intérêt agricole (SMIA) à conseil d'administration",
    "5532": "SA d'intérêt collectif agricole (SICA) à conseil d'administration",
    "5542": "SA d'attribution à conseil d'administration",
    "5543": "SA coopérative de construction à conseil d'administration",
    "5546": "SA de HLM à conseil d'administration",
    "5547": "SA coopérative de production de HLM à conseil d'administration",
    "5548": "SA de crédit immobilier à conseil d'administration",
    "5551": "SA coopérative de consommation à conseil d'administration",
    "5552": "SA coopérative de commerçants-détaillants à conseil d'administration",
    "5553": "SA coopérative artisanale à conseil d'administration",
    "5554": "SA coopérative (d'intérêt) maritime à conseil d'administration",
    "5555": "SA coopérative de transport à conseil d'administration",
    "5558": "SA coopérative ouvrière de production (SCOP) à conseil d'administration",
    "5559": "SA union de sociétés coopératives à conseil d'administration",
    "5560": "Autre SA coopérative à conseil d'administration",
    "5570": "Société de Participations Financières de Profession Libérale Société anonyme à conseil d'administration (SPFPL SA à conseil d'administration)",
    "5585": "Société d'exercice libéral à forme anonyme à conseil d'administration",
    "5599": "SA à conseil d'administration (s.a.i.)",
    "5605": "SA à participation ouvrière à directoire",
    "5610": "SA nationale à directoire",
    "5615": "SA d'économie mixte à directoire",
    "5620": "Fonds à forme sociétale à directoire",
    "5622": "SA immobilière pour le commerce et l'industrie (SICOMI) à directoire",
    "5625": "SA immobilière d'investissement à directoire",
    "5630": "Safer anonyme à directoire",
    "5631": "SA mixte d'intérêt agricole (SMIA)",
    "5632": "SA d'intérêt collectif agricole (SICA)",
    "5642": "SA d'attribution à directoire",
    "5643": "SA coopérative de construction à directoire",
    "5646": "SA de HLM à directoire",
    "5647": "Société coopérative de production de HLM anonyme à directoire",
    "5648": "SA de crédit immobilier à directoire",
    "5651": "SA coopérative de consommation à directoire",
    "5652": "SA coopérative de commerçants-détaillants à directoire",
    "5653": "SA coopérative artisanale à directoire",
    "5654": "SA coopérative d'intérêt maritime à directoire",
    "5655": "SA coopérative de transport à directoire",
    "5658": "SA coopérative ouvrière de production (SCOP) à directoire",
    "5659": "SA union de sociétés coopératives à directoire",
    "5660": "Autre SA coopérative à directoire",
    "5670": "Société de Participations Financières de Profession Libérale Société anonyme à Directoire (SPFPL SA à directoire)",
    "5685": "Société d'exercice libéral à forme anonyme à directoire",
    "5699": "SA à directoire (s.a.i.)",
    "5710": "SAS, société par actions simplifiée",
    "5720": "Société par actions simplifiée à associé unique ou société par actions simplifiée unipersonnelle",
    "5770": "Société de Participations Financières de Profession Libérale Société par actions simplifiée (SPFPL SAS)",
    "5785": "Société d'exercice libéral par action simplifiée",
    "5800": "Société européenne",
    "6100": "Caisse d'Épargne et de Prévoyance",
    "6210": "Groupement européen d'intérêt économique (GEIE)",
    "6220": "Groupement d'intérêt économique (GIE)",
    "6316": "Coopérative d'utilisation de matériel agricole en commun (CUMA)",
    "6317": "Société coopérative agricole",
    "6318": "Union de sociétés coopératives agricoles",
    "6411": "Société d'assurance à forme mutuelle",
    "6511": "Sociétés Interprofessionnelles de Soins Ambulatoires",
    "6521": "Société civile de placement collectif immobilier (SCPI)",
    "6532": "Société civile d'intérêt collectif agricole (SICA)",
    "6533": "Groupement agricole d'exploitation en commun (GAEC)",
    "6534": "Groupement foncier agricole",
    "6535": "Groupement agricole foncier",
    "6536": "Groupement forestier",
    "6537": "Groupement pastoral",
    "6538": "Groupement foncier et rural",
    "6539": "Société civile foncière",
    "6540": "Société civile immobilière",
    "6541": "Société civile immobilière de construction-vente",
    "6542": "Société civile d'attribution",
    "6543": "Société civile coopérative de construction",
    "6544": "Société civile immobilière d'accession progressive à la propriété",
    "6551": "Société civile coopérative de consommation",
    "6554": "Société civile coopérative d'intérêt maritime",
    "6558": "Société civile coopérative entre médecins",
    "6560": "Autre société civile coopérative",
    "6561": "SCP d'avocats",
    "6562": "SCP d'avocats aux conseils",
    "6563": "SCP d'avoués d'appel",
    "6564": "SCP d'huissiers",
    "6565": "SCP de notaires",
    "6566": "SCP de commissaires-priseurs",
    "6567": "SCP de greffiers de tribunal de commerce",
    "6568": "SCP de conseils juridiques",
    "6569": "SCP de commissaires aux comptes",
    "6571": "SCP de médecins",
    "6572": "SCP de dentistes",
    "6573": "SCP d'infirmiers",
    "6574": "SCP de masseurs-kinésithérapeutes",
    "6575": "SCP de directeurs de laboratoire d'analyse médicale",
    "6576": "SCP de vétérinaires",
    "6577": "SCP de géomètres experts",
    "6578": "SCP d'architectes",
    "6585": "Autre société civile professionnelle",
    "6588": "Société civile laitière",
    "6589": "Société civile de moyens",
    "6595": "Caisse locale de crédit mutuel",
    "6596": "Caisse de crédit agricole mutuel",
    "6597": "Société civile d'exploitation agricole",
    "6598": "Exploitation agricole à responsabilité limitée",
    "6599": "Autre société civile",
    "6901": "Autre personne de droit privé inscrite au registre du commerce et des sociétés",
    "9900": "Autre personne morale de droit privé"
  };

  // Convert number to string if needed
  const codeStr = code.toString();
  console.log('codeStr',codeStr);
  return forms[codeStr] || 'Forme juridique inconnue';
}